export default __webpack_public_path__ + "static/media/faq-mobile@2x.e335ab8b.webp";